import { Sparkles, ArrowRight, CheckCircle2, MapPin, CalendarDays, BarChart3 } from "lucide-react";
import { getIndustryPreviewConfig } from "./previewIndustryConfig";

function renderRealEstateVisual() {
    return (
        <div className="gip-realestate-layout">
            <div className="gip-re-topbar">
                <div className="gip-re-search" />
                <div className="gip-re-filter-row">
                    <span>Buy</span>
                    <span>Rent</span>
                    <span>2 BHK</span>
                    <span>Ahmedabad</span>
                </div>
            </div>

            <div className="gip-re-main">
                <div className="gip-re-map">
                    <div className="gip-re-map-pin pin-a" />
                    <div className="gip-re-map-pin pin-b" />
                    <div className="gip-re-map-pin pin-c" />
                </div>

                <div className="gip-re-listings">
                    {[1, 2].map((item) => (
                        <div className="gip-re-card" key={item}>
                            <div className="gip-re-card-image" />
                            <div className="gip-re-card-body">
                                <div className="gip-re-price" />
                                <div className="gip-re-line strong" />
                                <div className="gip-re-line" />
                                <div className="gip-re-tag-row">
                                    <span />
                                    <span />
                                    <span />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

function renderAcademyVisual() {
    return (
        <div className="gip-academy-layout">
            <div className="gip-ac-top">
                <div className="gip-ac-hero" />
                <div className="gip-ac-info">
                    <div className="gip-ac-line strong" />
                    <div className="gip-ac-line" />
                    <div className="gip-ac-line short" />
                </div>
            </div>

            <div className="gip-ac-grid">
                {[1, 2, 3].map((item) => (
                    <div className="gip-ac-card" key={item}>
                        <div className="gip-ac-badge" />
                        <div className="gip-ac-line strong" />
                        <div className="gip-ac-line" />
                        <div className="gip-ac-line short" />
                    </div>
                ))}
            </div>

            <div className="gip-ac-coach-row">
                {[1, 2, 3].map((item) => (
                    <div className="gip-ac-coach" key={item}>
                        <div className="gip-ac-avatar" />
                        <div className="gip-ac-mini-lines">
                            <span className="strong" />
                            <span />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

function renderHealthcareVisual() {
    return (
        <div className="gip-health-layout">
            <div className="gip-health-top">
                <div className="gip-health-appointment">
                    <div className="gip-health-cal" />
                    <div className="gip-health-mini-lines">
                        <span className="strong" />
                        <span />
                    </div>
                </div>
                <div className="gip-health-appointment">
                    <div className="gip-health-cal" />
                    <div className="gip-health-mini-lines">
                        <span className="strong" />
                        <span />
                    </div>
                </div>
            </div>

            <div className="gip-health-grid">
                {[1, 2, 3].map((item) => (
                    <div className="gip-health-card" key={item}>
                        <div className="gip-health-icon-wrap" />
                        <div className="gip-health-line strong" />
                        <div className="gip-health-line" />
                    </div>
                ))}
            </div>
        </div>
    );
}

function renderLegalVisual() {
    return (
        <div className="gip-legal-layout">
            <div className="gip-legal-hero" />
            <div className="gip-legal-stat-row">
                <div />
                <div />
                <div />
            </div>
            <div className="gip-legal-practice-grid">
                {[1, 2, 3].map((item) => (
                    <div className="gip-legal-card" key={item}>
                        <div className="gip-legal-line strong" />
                        <div className="gip-legal-line" />
                        <div className="gip-legal-line short" />
                    </div>
                ))}
            </div>
        </div>
    );
}

function renderSaasVisual() {
    return (
        <div className="gip-saas-layout">
            <div className="gip-saas-metric-row">
                {[1, 2, 3].map((item) => (
                    <div className="gip-saas-metric" key={item}>
                        <div className="gip-saas-metric-top" />
                        <div className="gip-saas-metric-value" />
                    </div>
                ))}
            </div>

            <div className="gip-saas-chart-wrap">
                <div className="gip-saas-sidebar" />
                <div className="gip-saas-chart-main">
                    <div className="gip-saas-chart-lines">
                        <span className="line-a" />
                        <span className="line-b" />
                        <span className="line-c" />
                    </div>
                </div>
            </div>

            <div className="gip-saas-feature-row">
                {[1, 2, 3].map((item) => (
                    <div className="gip-saas-feature" key={item}>
                        <div className="gip-saas-feature-icon" />
                        <div className="gip-saas-feature-lines">
                            <span className="strong" />
                            <span />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

function renderGenericVisual() {
    return (
        <div className="gip-generic-layout">
            <div className="gip-generic-hero" />
            <div className="gip-generic-grid">
                <div />
                <div />
                <div />
            </div>
        </div>
    );
}

function renderIndustryVisual(visualType) {
    switch (visualType) {
        case "real-estate":
            return renderRealEstateVisual();
        case "academy":
            return renderAcademyVisual();
        case "healthcare":
            return renderHealthcareVisual();
        case "legal":
            return renderLegalVisual();
        case "saas":
            return renderSaasVisual();
        default:
            return renderGenericVisual();
    }
}

function getContextIcon(visualType) {
    switch (visualType) {
        case "real-estate":
            return <MapPin size={14} />;
        case "academy":
        case "healthcare":
            return <CalendarDays size={14} />;
        case "saas":
            return <BarChart3 size={14} />;
        default:
            return <CheckCircle2 size={14} />;
    }
}

export default function GeneratorInstantPreview({ form, previewSeed }) {
    const config = getIndustryPreviewConfig(form, previewSeed);
    const ContextIcon = getContextIcon(config.visualType);

    return (
        <div
            className="gip-shell gip-realtime"
            key={`${config.businessName}-${config.industry}-${config.goal}-${config.brandStyle}`}
        >
            <div className="gip-grid">
                <div className="gip-copy">
                    <div className="gip-badge">
                        <Sparkles size={16} />
                        <span>Instant Preview</span>

                        <div className="gip-live-indicator">
                            <span className="gip-live-dot" />
                            Updating as you type
                        </div>

                    </div>

                    <h2 className="gip-title">
                        {config.businessName || "Your Business"} website preview
                    </h2>

                    <p className="gip-subtitle">{config.subtitle}</p>

                    <div className="gip-ai-insight">
                        <span>AI is preparing</span>

                        <div className="gip-ai-insight-row">
                            <div>
                                <strong>{config.pages.length}</strong>
                                <small>Pages</small>
                            </div>

                            <div>
                                <strong>CRM</strong>
                                <small>Modules</small>
                            </div>

                            <div>
                                <strong>A/B</strong>
                                <small>Variants</small>
                            </div>

                            <div>
                                <strong>AI</strong>
                                <small>Images</small>
                            </div>
                        </div>
                    </div>

                    <div className="gip-actions">
                        <button type="button" className="landing-btn landing-btn-primary" disabled>
                            {config.primaryCta}
                            <ArrowRight size={16} />
                        </button>

                        <button type="button" className="landing-btn landing-btn-secondary" disabled>
                            {config.secondaryCta}
                        </button>
                    </div>

                    <div className="gip-tags">
                        {[config.industry, config.goal, config.brandStyle].map((tag) => (
                            <span key={tag} className="gip-tag">
                                {ContextIcon}
                                {tag}
                            </span>
                        ))}
                    </div>

                    <div className="gip-system-hint">
                        <Sparkles size={14} />
                        <span>
                            This preview will become a live website with CRM, AI editing, and deployment tracking.
                        </span>
                    </div>

                    <div className="gip-system-plan">
                        <span>{form.visualDirection || "AI visual direction"}</span>
                        <span>{form.imageStrategy || "mixed images"}</span>
                        <span>
                            {Array.isArray(form.crmModules) && form.crmModules.length > 0
                                ? `${form.crmModules.length} CRM modules`
                                : "CRM-ready"}
                        </span>
                    </div>
                </div>

                <div className="gip-visual">
                    <div className={`gip-browser gip-browser--${config.visualType}`}>
                        <div className="gip-browser-top">
                            <span />
                            <span />
                            <span />

                            <div className="gip-browser-url">
                                {config.businessName?.toLowerCase().replace(/\s+/g, "") || "your-site"}.nexus.site
                            </div>
                        </div>

                        <div className="gip-browser-body gip-browser-body--industry">
                            <div className="gip-industry-head">
                                {config.chips.map((chip) => (
                                    <span key={chip} className="gip-chip">
                                        {chip}
                                    </span>
                                ))}
                            </div>

                            {renderIndustryVisual(config.visualType)}

                            <div className="gip-pages">
                                {config.pages.map((page) => (
                                    <span key={page}>{page}</span>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}